import React from "react";
import Heading from "utils/Heading";
import LinkedinIcon from "images/linkedin_icon_rounded.svg";

const BigTextLinks = ({ blok }) => {
  return (
    <div className="my-12 lg:my-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="mb-16 block gap-10 lg:flex lg:flex-row">
          <Heading size="h2" className="!text-6xl md:!text-[146px]">
            <a href="mailto:hello@stanleyandco.com">{blok.mailto_link}</a>
          </Heading>
        </div>
        <div className="flex flex-col flex-wrap gap-x-5 gap-y-10 lg:flex-row">
          <Heading size="h2" className="relative !text-6xl md:!text-[146px]">
            <a href={`mailto:${blok.nikki_email}`}>Nikki</a>,
            <span className="absolute top-[-30px] lg:right-0">
              <a href={`${blok.nikki_linkedin}`}>
                <LinkedinIcon width="45" />
              </a>
            </span>
          </Heading>
          <Heading size="h2" className="relative !text-6xl md:!text-[146px]">
            <a href={`mailto:${blok.jane_email}`}>Jane</a>
            <span className="absolute top-[-30px] lg:right-0">
              <a href={`${blok.jane_linkedin}`}>
                <LinkedinIcon width="45" />
              </a>
            </span>
          </Heading>
          <Heading size="h2" className="relative  !text-6xl md:!text-[146px]">
            <a href={`mailto:${blok.michael_email}`}>& Michael.</a>
            <span className="absolute top-[-30px] lg:right-0">
              <a href={`${blok.michael_linkedin}`}>
                <LinkedinIcon width="45" />
              </a>
            </span>
          </Heading>
        </div>
      </div>
    </div>
  );
};

export default BigTextLinks;
